import React from "react";
import { BASE_URL } from "./utility";
import { Link } from "react-router-dom";

export default function SocialMediaLinks() {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Products", href: "/products" },
    { name: "About Us", href: "/about" },
  ];

  const socialLinks = [
    { name: "Facebook", href: "https://www.facebook.com/rainbowtouchindia/", icon: "facebook" },
    { name: "Gmail", href: "mailto:rainbowtouchindia@gmail.com", icon: "gmail" },
    { name: "Instagram", href: "https://www.instagram.com/", icon: "insta" },
    { name: "Twitter", href: "https://twitter.com/", icon: "twitter" },
  ];

  return (
    <footer
      style={{
        backgroundColor: "#1a1a1a",
        color: "white",
        padding: "2rem 1rem",
        marginTop: "2rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.5rem",
        }}
      >
        {/* Navbar Links */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "1rem 2rem",
          }}
        >
          {navLinks.map((link, idx) => (
            <Link
              key={idx}
              to={link.href}
              style={{ color: "white", textDecoration: "none", fontWeight: "500" }}
            >
              {link.name}
            </Link>
          ))}
        </div>

        {/* Social Media Links */}
        <div style={{ display: "flex", gap: "1rem" }}>
          {socialLinks.map((social, idx) => (
            <a
              key={idx}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={BASE_URL + "download/social/" + social.icon}
                alt={social.name}
                width={40}
                height={40}
                style={{ borderRadius: "50%", transition: "transform 0.3s" }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div style={{ fontSize: "0.9rem", textAlign: "center", marginTop: "1rem" }}>
          © 2005 - {new Date().getFullYear()} Rainbow Touch. All rights reserved.{" "}
          <a
            href="http://www.rainbowtouchindia.com/"
            style={{ color: "#ffcc00", textDecoration: "none" }}
          >
            rainbowtouchindia.com
          </a>
        </div>
      </div>
    </footer>
  );
}
